<template>
  <div class="row">
    <div
      v-if="!open && calendar.days.length > 0"
      :class="day ? 'col-lg-8' : 'col-lg-8'"
    >
      <table class="mt-4 w-100">
        <thead>
          <tr>
            <td style="width:14%;" v-for="day in calendar.labeldays">
              <div class="text-center">
                <small class="text-center text-uppercase text-secondary">{{
                  $t("lang.label." + day)
                }}</small>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-for="(i, k) in [0, 1, 2, 3, 4, 5, 6]">
              <Day :i="i" :nodays="nodays" :calendar="calendar" :day="day" @showDay="showDay($event)"></Day>
            </td>
          </tr>
          <tr>
            <td v-for="(i, k) in [7, 8, 9, 10, 11, 12, 13]">
              <Day :i="i" :nodays="nodays" :calendar="calendar" :day="day" @showDay="showDay($event)"></Day>
            </td>
          </tr>
          <tr>
            <td v-for="(i, k) in [14, 15, 16, 17, 18, 19, 20]">
              <Day :i="i" :nodays="nodays" :calendar="calendar" :day="day" @showDay="showDay($event)"></Day>
            </td>
          </tr>
          <tr>
            <td v-for="(i, k) in [21, 22, 23, 24, 25, 26, 27]">
              <Day :i="i" :nodays="nodays" :calendar="calendar" :day="day" @showDay="showDay($event)"></Day>
            </td>
          </tr>
          <tr>
            <td v-for="(i, k) in [28, 29, 30, 31, 32, 33, 34]">
              <Day :i="i" :nodays="nodays" :calendar="calendar" :day="day" @showDay="showDay($event)"></Day>
            </td>
          </tr>
          <tr>
            <td v-for="(i, k) in [35, 36, 37, 38, 39, 40, 41]">
              <div class="pt-2 text-center text-secondary">
                <span v-if="calendar.days[i] == 1">{{ i + 1 - nodays }}</span>
                <span
                  v-if="day == i + 1 - nodays"
                  class="cursor-pointer bg-secondary text-white rounded-circle"
                  style="width:40px;height:40px;padding-top:8px;"
                  >{{ i + 1 - nodays }}</span
                >
                <span
                  v-if="calendar.days[i] == 2 && day != i + 1 - nodays"
                  :class="
                    calendar.days[i] == 2
                      ? 'cursor-pointer bg-primary text-white rounded-circle'
                      : ''
                  "
                  style="width:40px;height:40px;padding-top:8px;"
                  @click="showDay(i + 1 - nodays)"
                  >{{ i + 1 - nodays }}</span
                >
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <Modal :name="'noSlotsAvailable'" :close="false" size="30">
        <div class="p-4 text-center">
          <label>
            <h4>{{ $t('lang.calendar.noslotsavailablethismonth',{'month': $t("lang.label." + monthlabel )}) }}</h4>
          </label>
          <a class="text-primary m-2 border p-3 rounded" type="button" @click="goToNextMonth()">
            {{ $t("lang.calendar.seenextmonth") }}
            <i class="icon-arrow-right"></i>
          </a>
        </div>


      </Modal>
    </div>

    <div class="col-lg-4">
      <div v-if="loadingHourly">
        <span
          class="loadingres d-flex p-2 spinner-border loading-spinner mx-auto"
        >
        </span>
      </div>
      <span v-if="hourly.length == 0 && !loadingHourly" class="card p-2">
        <span class="d-inline">{{$t('lang.calendar.notavailable')}}</span>
      </span>
      <CalendarHourly
        v-if="!loadingHourly && hourly && !open"
        @open="openForm($event)"
        :hours="hourly"
      ></CalendarHourly>

    </div>
    <div class="col-md-12">
      <div class="row mt-3">
        <div class="col-md-9" v-if="!open">
          <i class="icon-globe"></i> {{ $t("lang.calendar.timezone") }}
        </div>
      </div>
    </div>
    <div class="col-md-8">
      <div class="row mt-3">
        <div class="col-md-9" v-if="!open">
          <select
            v-model="timezone"
            @change="selectTimeZone()"
            class="form-control w-100"
          >
            <option value="false" v-if="!timezone" selected>
              {{ $t("lang.label.choose") }}
            </option>
            <option
              v-for="(lang, i) in timezones"
              :key="`Lang${i}`"
              :value="lang.id"
            >
              {{ lang.label }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div v-if="open" class="col-md-12">
      <div class="mt-3">
        <vue-form-generator
          ref="schemaStatusV"
          :schema="schemaStatus"
          :model="modelform"
          :options="formOptions"
        ></vue-form-generator>
        <div class="col-md-12">
          <button class="btn btn-primary" @click="createEvent()">
            {{ $t("lang.button.save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import CalendarHourly from "@/components/Calendar/CalendarHourly.vue";
import Day from "@/components/Calendar/Day.vue";
import VueFormGenerator from "vue-form-generator";
import Modal from "@/components/Common/Modal.vue";
import { myCalendarService, countriesService } from "@/_services";
import {
  applyPrefillToModelForm,
  findMatchingHourSlot,
  isCalendarDaysGridComplete,
  isDayAvailableInCalendar,
  normalizeCalendarHashForPayload,
  canInsertCalendarActivity,
} from "@/_helpers/calendarPrefill";

Vue.use(VueFormGenerator, {
  validators: {
    notAcceptNumberOrEmail: (value, field, model) => {
      const notNumber = /^([^0-9]*)$/;
      const notUrl = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi
      if (!notNumber.test(value) || value.match(/@/gi) || value.match(notUrl)) {
        return [i18n.t("lang.validation.not_number_and_email")];
      } else {
        return [];
      }
    },
  },
});

export default {
  data() {
    return {
      countries: [],
      countryNames: ['France'],
      myhs:false,
      myhsdefault:false,
      isEmail: false,
      timezone: false,
      hourchoose: false,
      open: false,
      nodays: 0,
      slotsAvailable: false,
      day: false,
      loadingHourly: false,
      modelform: {
        first_name: "",
        last_name: "",
        company_name: "",
        phone: "",
        country: "",
        url: "",
        email: "",
        emails: [],
        comments: "",
      },
      schemaStatus: {
        fields: [
          {
            type: "input",
            inputType: "text",
            styleClasses: "col-md-6",
            model: "first_name",
            featured: true,
            required: true,
            label: this.$t("lang.label.firstname"),
            max: 50,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
            }),
          },
          {
            type: "input",
            inputType: "text",
            styleClasses: "col-md-6",
            model: "last_name",
            featured: true,
            required: true,
            label: this.$t("lang.label.lastname"),
            max: 50,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
            }),
          },
          {
            type: "input",
            inputType: "text",
            styleClasses: "col-md-6",
            model: "company_name",
            featured: true,
            required: true,
            label: this.$t("lang.label.companyname"),
            min: 5,
            max: 50,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
          },
          {
            type: "autocomplete", 
            styleClasses: "col-md-6",
            label: "Country",
            model: "country",
            placeholder: "Select a country...",
            required: false,
            featured: true,
            multiple: false,
            values: [],
            onSearch: async (searchTerm, callback) => {
              if(this.countries.length > 0){
                const filtered = this.countryNames.filter( country =>
                  country.toLowerCase().includes(searchTerm.toLowerCase())
                );
                callback(filtered); 
              }
              
            },
          },
          {
            type: "phone",
            styleClasses: "col-md-6",
            model: "phone",
            min: 8,
            featured: true,
            required: true,
            label: this.$t("lang.label.mobile_phone"),
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            fieldOptions: {
              dynamicPhoneValue: null // Inicializa el valor
            },            
          },
          {
            type: "input",
            inputType: "url",
            styleClasses: "col-md-6",
            label: this.$t("lang.label.website"),
            model: "url",
            id: "url",
            featured: true,
            required: true,
            validator: VueFormGenerator.validators.required,
          },
          {
            type: "input",
            inputType: "email",
            styleClasses: "col-md-12",
            label: this.$t("lang.column.email"),
            model: "email",
            id: "email",
            featured: true,
            required: true,
            validator: VueFormGenerator.validators.email,
          },
          {
            type: "vueMultiSelect",
            model: "emails",
            styleClasses: "col-md-12 em",
            label: "<b>" + this.$t("lang.label.otherguests") + "</b>",
            id: "emails",
            values: [],
            required: false,
            multiSelect: true,
            placeholder: this.$t("lang.calendar.addOtherguests"),//"Add your invitees e-mail here (ex:john.doe@company.com)",
            selectOptions: {
              onSearch: (value) => {
                let isEmailValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;

                if (isEmailValid.test(value) && value.length > 6) {
                  this.emailTagPlaceholder.selectOptions.tagPlaceholder = this.$t("lang.calendar.addGuestToList")//'Press enter to add this e-mail to the list';
                } else {
                  this.emailTagPlaceholder.selectOptions.tagPlaceholder = this.$t("lang.calendar.emailValid")//'Enter email valido';
                }
              },
              multiple: true,
              trackBy: "value",
              label: "name",
              taggable: true,
              searchable: true,
              closeOnSelect: true,
              hideSelected: true,
              tagPlaceholder: this.$t("lang.calendar.emailValid"),
              //validator: VueFormGenerator.validators.email,
              onNewTag(newTag, id, options, value) {
                const isEmailValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;

                const currentValues = value.map( el => el.value);

                if (isEmailValid.test(newTag) && !currentValues.includes(newTag)) {
                  const tag = {
                      name: newTag,
                      icon: "none",
                      custom: true,
                      value: newTag,
                    };
                  value.push(tag);
                }
              },
            },
          },
          {
            type: "textArea",
            styleClasses: "col-md-12",
            label: this.$t("lang.label.comments"),
            model: "comments",
            featured: true,
            hint: this.$t("lang.label.max500characters"),
            max: 500,
            rows: 2
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      hourly: false,
      emailTagPlaceholder: null,
      prefillProcessed: false,
      prefillAttemptStarted: false,
    };
  },
  props: {
    calendar: Object,
    timezones: Array,
    monthlabel: String,
    canLoadCountries: {
      type: Boolean,
      default: false,
    },
    calendarPrefill: {
      type: Object,
      default: null,
    },
    calendarDaysSettled: {
      type: Boolean,
      default: true,
    },
    businessContactHash: {
      default: null,
    },
    campaignHash: {
      default: null,
    },
    selectedTimezone: {
      default: false,
    },
  },
  components: {
    CalendarHourly,
    "vue-form-generator": VueFormGenerator.component,
    Modal,
    Day
  },
  created() {
      const textToHash = "oliverlististhebest"+ Math.floor(Math.random() * 100) + 1;
      this.myhsdefault = textToHash;
      // Convertir la cadena a bytes
      const bytes = new TextEncoder().encode(textToHash);
      // Aplicar SHA-256
      if(window.crypto && window.crypto.subtle){
        window.crypto.subtle.digest('SHA-1', bytes).then(hashBuffer => {
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');

          // Mostrar el hash en hexadecimal
          this.myhs = hashHex;
        }).catch(error => {
        });
      } else {
        this.myhs = textToHash;
      }
    this.syncTimezoneFromParent();

    if (this.calendarPrefill && this.calendarPrefill.formFields) {
      applyPrefillToModelForm(this.modelform, this.calendarPrefill.formFields);
    }
  },
  mounted() {

    if (this.calendar.days.length > 0) {
      const firstDay = new Date(this.calendar.currentyear, this.calendar.currentmonth - 1, 1);
      const dow = firstDay.getDay(); // 0=dom, 1=lun, ..., 6=sab
      this.nodays = dow === 0 ? 6 : dow - 1; // semana lunes-domingo

      this.calendar.days.forEach((k) => {
        if (k > 1) {
          this.slotsAvailable = true;
        }
      });
      if (!this.slotsAvailable){
        this.$modal.show("noSlotsAvailable");
      }
    }
    this.emailTagPlaceholder = this.schemaStatus.fields.find( e => e.type === 'vueMultiSelect' && e.id === 'emails')
  },
  computed: {
    currntUserId() {
      return this.$store.state.authentication.user != undefined
        ? this.$store.state.authentication.user.id
        : 0;
    },
    textPlaceholderInvites(){
      if(this.isEmail){
        return "valido....."
      } else {
        return " no valido..."
      }
    }
  },
  watch: {
    selectedTimezone: {
      immediate: true,
      handler() {
        this.syncTimezoneFromParent();
      },
    },
    "calendar.timezone"() {
      this.syncTimezoneFromParent();
    },
    "calendar.defaultTimezone"() {
      this.syncTimezoneFromParent();
    },
    'modelform.country': function (newVal, oldVal) {
        if( this.countries.length > 0){
          const country = this.countries.find( el => el.name == newVal)
         if(country && country.phone_code && country.iso) {
            this.modelform.phone = "+"+ country.phone_code
            this.schemaStatus.fields.find( el => el.type == 'phone').fieldOptions.dynamicPhoneValue = country.iso.toLowerCase();
          }         
        }    
    },
    canLoadCountries: {
      immediate: true,
      handler(newValue) {
        if (newValue && this.countries.length === 0) {
          this.geCountries();
        }
      },
    },
    "calendar.days": {
      immediate: true,
      handler() {
        this.onCalendarDaysReady();
      },
    },
    calendarDaysSettled(isSettled) {
      if (isSettled) {
        this.onCalendarDaysReady();
      }
    },
  },
  methods: {
    syncTimezoneFromParent() {
      if (this.selectedTimezone) {
        this.timezone = this.selectedTimezone;
        return;
      }

      if (this.calendar && this.calendar.timezone !== undefined) {
        this.timezone = this.calendar.timezone;
        return;
      }

      if (this.calendar && this.calendar.defaultTimezone) {
        this.timezone = this.calendar.defaultTimezone;
      }
    },
    onCalendarDaysReady() {
      if (!this.calendarPrefill || this.prefillProcessed) {
        return;
      }

      if (!this.calendarDaysSettled || !isCalendarDaysGridComplete(this.calendar.days)) {
        return;
      }

      const parsedDate = this.calendarPrefill.parsedDate;
      if (!parsedDate) {
        this.prefillProcessed = true;
        return;
      }

      if (
        parsedDate.month !== this.calendar.currentmonth ||
        parsedDate.year !== this.calendar.currentyear
      ) {
        return;
      }

      if (!this.calendarPrefill.canSkipToSchema) {
        this.prefillProcessed = true;
        return;
      }

      this.tryPrefillMeetingSlot();
    },
    resetPrefillSelection() {
      this.day = false;
      this.open = false;
      this.hourchoose = false;
      this.hourly = false;
      this.loadingHourly = false;
      this.$emit("clearday");
    },
    showPrefillUnavailableAlert() {
      this.$swal({
        title: "Date or time not available",
        text: "Please choose manually.",
        icon: "info",
        showCancelButton: false,
        confirmButtonText: "OK",
      });
    },
    tryPrefillMeetingSlot() {
      if (this.prefillAttemptStarted || this.prefillProcessed) {
        return;
      }

      this.prefillAttemptStarted = true;

      const parsedDate = this.calendarPrefill.parsedDate;
      const parsedTime = this.calendarPrefill.parsedTime;

      if (
        !isDayAvailableInCalendar(
          parsedDate.day,
          parsedDate.month,
          parsedDate.year,
          this.calendar.days
        )
      ) {
        this.showPrefillUnavailableAlert();
        this.resetPrefillSelection();
        this.prefillProcessed = true;
        return;
      }

      if (!this.myhs) {
        this.myhs = this.myhsdefault;
      }

      myCalendarService
        .getAvailabilityByDay(
          parsedDate.day,
          this.calendar.currentmonth,
          this.calendar.currentyear,
          this.calendar.accountId,
          this.calendar.timezone,
          this.myhs
        )
        .then((res) => {
          const slot = findMatchingHourSlot(parsedTime, res);

          if (slot) {
            this.day = parsedDate.day;
            this.hourly = res;
            this.loadingHourly = false;
            this.$emit("showday", this.day);
            this.openForm(slot);
          } else {
            this.showPrefillUnavailableAlert();
            this.resetPrefillSelection();
          }

          this.prefillProcessed = true;
        })
        .catch(() => {
          this.showPrefillUnavailableAlert();
          this.resetPrefillSelection();
          this.prefillProcessed = true;
        });
    },
    goToNextMonth(){
      this.$modal.hide("noSlotsAvailable")
      this.slotsAvailable = false

      if(canInsertCalendarActivity(this.businessContactHash, this.campaignHash)){
        myCalendarService.insertActivity(this.campaignHash,this.businessContactHash, true, 'No-Slot Next Month: ' + this.calendar.currentyear + '/'+this.calendar.currentmonth);
      }

      this.$emit('nextMonth')

    },
    showDay(day) {

      if(day == 'empty'){
        this.loadingHourly = false;
         this.hourly = [];
         return
      }

      if(!this.myhs){
        this.myhs = this.myhsdefault
      }
      this.loadingHourly = true;
      this.day = day;
      myCalendarService
        .getAvailabilityByDay(
          day,
          this.calendar.currentmonth,
          this.calendar.currentyear,
          this.calendar.accountId,
          this.calendar.timezone,
          this.myhs
        )
        .then((res) => {
          this.loadingHourly = false;
          this.hourly = res;
        });
      this.$emit("showday", this.day);

    if(canInsertCalendarActivity(this.businessContactHash, this.campaignHash)){
      myCalendarService.insertActivity(this.campaignHash,this.businessContactHash, true, 'Day: ' + this.calendar.currentyear + '/'+this.calendar.currentmonth+'/'+this.day);
    }

    },
    selectTimeZone() {
      this.$emit("timezone", this.timezone);
    },
    openForm(hour) {
      this.open = true;
      this.hourchoose = hour;
      let day = [
        this.day,
        this.calendar.currentmonth,
        this.calendar.currentyear,
        hour,
      ];
      this.$emit("open", day);

      if(canInsertCalendarActivity(this.businessContactHash, this.campaignHash)){
      myCalendarService.insertActivity(this.campaignHash,this.businessContactHash, true, 'Hour: ' + this.calendar.currentyear + '/'+this.calendar.currentmonth+'/'+this.day+' '+hour);
      }
    },
    createEvent() {
      this.$refs.schemaStatusV.validate();
      if (this.$refs.schemaStatusV.errors.length > 0) {
        return false;
      }


      if(!this.myhs){
        this.myhs = this.myhsdefault
      }

      //if (this.modelform.phone.length < 6) this.modelform.phone = ""

      let data = {
        modelform: this.modelform,
        account_id: this.calendar.accountId,
        day: this.day,
        month: this.calendar.currentmonth,
        year: this.calendar.currentyear,
        hour: this.hourchoose,
        business_contact_hash: normalizeCalendarHashForPayload(this.businessContactHash),
        campaign_hash: normalizeCalendarHashForPayload(this.campaignHash),
        timezone_id: this.timezone || this.selectedTimezone || this.calendar.timezone || this.calendar.defaultTimezone,
        bdr_user_id: this.currntUserId,
        s: this.myhs
      };
      this.$emit("eventcreated", this.modelform);
      this.$emit("createEvent",data);
    },
    addEmail(email) {
      this.modelform.emails.push(email);
    },
    geCountries() {
      const COUNTRIES_KEY = "countries";

      try {
        const cachedCountries = JSON.parse(localStorage.getItem(COUNTRIES_KEY));
        if (cachedCountries && cachedCountries.length > 0) {
          this.countryNames = cachedCountries.map((el) => el.name);
          const cachedCountryField = this.schemaStatus.fields.find(
            (field) => field.model === "country"
          );
          if (cachedCountryField) {
            cachedCountryField.values = [...this.countryNames];
          }
          this.countries = cachedCountries;
          return;
        }
      } catch (e) {
      }

      countriesService.getAll()
        .then((result) => {
        localStorage.setItem(COUNTRIES_KEY, JSON.stringify(result));
        this.countryNames = result.map(el => el.name);

        const countryField = this.schemaStatus.fields.find(
          (field) => field.model === "country"
        );
        if (countryField) {
          countryField.values = [...this.countryNames]; // Asigna el Array actualizado
        }
        this.countries = result
    });
  },
  },
  
};

</script>


<style scoped>
>>> .multiselect__placeholder {
  font-style: italic;
  font-size: 14px;
}
>>> .multiselect__tags input placeholder {
  font-style: italic;
  font-size: 3px;
}

>>> .multiselect__input {
  font-style: italic;
  font-size: 14px;
}
</style>
